import * as gs from './_csGbl';
import * as f from './_cmFTH';

import * as hf from './_hf';
import * as ht from './_ht';
import * as ihd from 'src/ihd';

export const ilz_80z = () => ({ // 新規登録を考慮し、毎回新規生成
  _81rz: {},
  _811s: [],
}) as ht.dz;

export const crt_80z = () => {
  const __80z = ilz_80z();
  hf.udtDz(__80z._81rz, {
    ... ihd.i('_81r'),
  });
  return __80z;
};

export const load_81rDzAsync = async (pz: {
  _81rt1100s?: ht.s,
  _81ra1100k?: ht.n,
  _81ra2100s?: ht.s, // cmrId
  _811a1100s?: ht.s,
  _811s1100i?: ht.n,
  lwrType?: 1,
}) => {
  let _cdn = f.vdd(false); // 履歴管理対象外
  if (pz._81ra1100k) _cdn += ` AND _81ra1100k = ${pz._81ra1100k} AND _81rt1100s = '${pz._81rt1100s}'`;
  if (pz._81ra2100s) _cdn += ` AND _81ra2100s = '${pz._81ra2100s}'`;
  if (pz._811a1100s) _cdn += ` AND _key IN (SELECT _811_81r1k FROM _811s WHERE ${f.vdd()} AND _811a1100s = '${pz._811a1100s}')`;
  const _dz = await f.loadDzAsync({
    tgt: '_81rs',
    cdn: _cdn,
    lwrz: 
      pz.lwrType == 1 ?
      {
        _811s: {
          tgt: '_811s',
          cdn: 
            f.vdd(false) 
            + ` AND _811_81r1k = {_81r_key}` 
            + (pz._811a1100s ? ` AND _811a1100s = '${pz._811a1100s}'` : '')
            + (pz._811s1100i ? ` AND _811s1100i = ${pz._811s1100i}` : ''),
          rlcz: {
            _81r_key: '_81rs._key',
          },
        },
      }
      : undefined,

  });
  return {
    _81rz: { ... _dz, cldz: undefined },
    _811s: _dz?.cldz?._811s ?? [],
  };
};

export const save_81rDzAsync = async (pz: {
  _80z: ht.dz,
  sPz?: ht.dz,
}) => {
  const _cdn = f.vdd(false) + ` AND _81ra1100s = '${pz._80z._81rz._81ra1100s ?? ''}' AND _81rt1100s = '${pz._80z._81rz._81rt1100s ?? ''}'`; // 1ユーザ1決済情報（履歴対象外）
  const _dz = await f.upsDzAsync({
    tgt: '_81rs',
    cdn: _cdn,
    dz: {
      ... pz._80z._81rz,
    },
    lwrz: {
      _811s: {
        tgt: '_811s',
        cdn: f.vdd(false) + ` AND _811a1100s = {_811a1100s}`, // 1 ssnId
        rlcz: {
          _811a1100s: '_811s._811a1100s',
        },
        ls: pz._80z._811s,
        udts: {
          _811_81r1k: '_81rs._key',
        }
      }
    }
  });
  if (pz.sPz) pz.sPz.set({
    _81r_fst: _dz._fst,
  })
  return {
    _81rz: { ... _dz, cldz: undefined },
  };
};
